export const baseFetch = url => {
	if (!url) return;
	return fetch(url).then((response) => response.json()).then(data =>  data);
}

export const getProducts = () => baseFetch("https://rvmp.co/products.json?limit=10000");
